// <copyright file="home.ts" company="BD">
// Copyright (c) BD. All rights reserved.
// Created: 11/05/2025 by Sumanth Satheesh
// </copyright>

import { Component, inject } from "@angular/core";
import { Header } from "../header/header";
import { UserContextService } from "../../services/userprofileservice";
import { RouterOutlet } from "@angular/router";

@Component({
  selector: "app-home",
  imports: [Header, RouterOutlet],
  templateUrl: "./home.html",
  styleUrl: "./home.scss"
})
export class Home {
  userProfileInfo = inject(UserContextService);
}
